import React, { useEffect, useState } from "react";
import { useCardSettlementSummary } from "../../../services/dashboard";
import ChartDropDown from "../../chartDropDown";
import { PieChart } from "../pieChart";
import { ICardSettlementResponse } from "../../../interface/dashboard";
import { isCurrency } from "../../../utils/isCurrency";

const CardSettlementChart = () => {
  let date = new Date();
  let rangeStartDate = `${date.getDate() - 5}-${
    date.getMonth() + 1
  }-${date.getFullYear()}`;

  let rangeEndDate = new Date().toLocaleDateString().replaceAll("/", "-");

  const [openDropDown, setopenDropDown] = useState<boolean>(false);
  const [period, setPeriod] = useState("Today");
  const [cardSettlementSummary, setCardSettlementSummary] =
    useState<ICardSettlementResponse>();
  const [range, setRange] = useState<{ startDate: string; endDate: string }>({
    startDate: rangeStartDate,
    endDate: rangeEndDate,
  });

  const { data } = useCardSettlementSummary(
    period === "Today" ? {} : { ...range }
  );

  const totalSum =
    data?.data.creation! + data?.data.topUp! + data?.data.withdraw!;

  const pieChartData = {
    labels: ["Creation", "TopUp", "Withdraw"],
    datasets: [
      {
        data: [
          cardSettlementSummary?.creation!,
          cardSettlementSummary?.topUp!,
          cardSettlementSummary?.withdraw!,
        ],
        backgroundColor: ["#ff6384", "#36a2eb", "#ffce56"],
      },
    ],
  };

  useEffect(() => {
    if (period === "Today") {
      setCardSettlementSummary(data?.data!);
    }
    if (period === "Range") {
      setCardSettlementSummary(data?.data!);
    }
  }, [data, period]);

  return (
    <div className="border border-grey p-4 mt-8 bg-dimGray rounded-md">
      <div className="pb-4 flex justify-between items-center">
        <h3 className="font-semibold">
          Card Settlement{" "}
          <span className="font-normal text-xs">
            (₦
            {isCurrency(totalSum || 0)})
          </span>
        </h3>
        <ChartDropDown
          open={openDropDown}
          setOpen={setopenDropDown}
          value={period}
          setValue={setPeriod}
          data={periodArray}
          range={range!}
          setRange={setRange}
        />
      </div>
      <div className=" h-[320px] w-full">
        <PieChart data={pieChartData} />
      </div>
    </div>
  );
};

export default CardSettlementChart;

const periodArray = [
  {
    label: "Today",
  },
  {
    label: "Range",
  },
];
